import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LunchPlanWaiverFormComp from '../../../../components/registrationPacket/LunchPlanWaiverFormComp';
import { fetchLunchPlanWaivers } from '../../../../store/lunchPlanWaiver/lunchPlanWaiverSlice';
import { getEffectiveStudentId } from '../../../../utilities/teacherModulePermissions';

const LunchPlanWaiverForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);
  let profileData = useSelector((state) => state.setting.setting.user_data);
  profileData = profileData ? JSON.parse(profileData) : null;

  // LunchPlanWaiverFormComp resolves the record to edit from Redux via
  // selectWaiverById, which only has data once the list page has fetched
  // it. Direct navigation to this edit URL (refresh, deep link, or a link
  // from elsewhere) previously rendered a blank form since nothing here
  // ever populated the store. Dispatching the same fetch here too closes
  // that gap, mirroring allergy-action-plan-form.js's fix for the
  // identical bug.
  useEffect(() => {
    if (!isEditMode) return;
    dispatch(fetchLunchPlanWaivers({ page: 1, limit: 20, student_id: getEffectiveStudentId(profileData) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, id]);

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title d-flex align-items-center">
                <i className="icon material-symbols-outlined me-2" style={{ verticalAlign: 'middle', fontSize: '22px' }}>restaurant</i>
                <h4 className="card-title mb-0">
                  {isEditMode ? 'Edit' : 'Create'} Lunch Plan Waiver
                </h4>
              </div>
              <Button variant="outline-secondary" onClick={() => navigate('/dashboard/lunch-plan-waiver/list')}>
                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>arrow_back</i>
                Back to List
              </Button>
            </Card.Header>
            <Card.Body>
              <LunchPlanWaiverFormComp isEditMode={isEditMode} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LunchPlanWaiverForm;
